<template lang="html">
  <div v-if="type==1" class="editor">
    <div ref="toolbar" class="toolbar">
    </div>
    <div ref="editor" class="text">
    </div>
  </div>
  <div v-else-if="type==2" class="editor2">
    <div ref="toolbar" :class="barClass">
    </div>
    <div ref="editor" class="text2">
    </div>
  </div>
</template>

<script>
    import E from "wangeditor";
    export default {
        name: "Editorbar",
        data() {
            return {
                editor: null,
                info_: null,
            };
        },
        model: {
            prop: "value",
            event: "change",
        },
        props: {
            value: {
                type: String,
                default: "",
            },
            isClear: {
                type: Boolean,
                default: false,
            },
            type: {
                default: 1,
            },
            barSet: {
                default: 0,
            },
            barClass: {
                type: String,
                default: "toolbar2",
            }
        },
        watch: {
            isClear(val) {
                // 触发清除文本域内容
                if (val) {
                    this.editor.txt.clear();
                    this.info_ = null;
                }
            },
            value(val) {
                // 使用 v-model 时，设置初始值
                if (val !== this.editor.txt.html()) {
                    this.editor.txt.clear();
                    this.editor.txt.html(val);
                }

                document.querySelectorAll('table').forEach(element => {
                    if (element.style.width == "" || element.style.width == "undefined" || element.style.width == null)
                        element.style.width = "100%";
                });
            },
        },
        mounted() {
            this.seteditor();
        },
        methods: {
            seteditor() {
                this.editor = new E(this.$refs.toolbar, this.$refs.editor);
                this.editor.config.pasteFilterStyle = false;
                this.editor.config.pasteIgnoreImg = false;
                this.editor.config.showFullScreen = true;
                // 配置菜单v
                if (this.type == 1) {
                    this.editor.config.zindex = 1;
                    this.editor.config.menus = [
                        "head", // 标题
                        "bold", // 粗体
                        "fontSize", // 字号
                        "fontName", // 字体
                        "italic", // 斜体
                        "underline", // 下划线
                        "strikeThrough", // 删除线
                        "indent", //缩进
                        "lineHeight", //行高
                        "foreColor", // 文字颜色
                        "backColor", // 背景颜色
                        "link", // 插入链接
                        "list", // 列表
                        "justify", // 对齐方式
                        "quote", // 引用
                        "emoticon", // 表情
                        "image", // 插入图片
                        "table", // 表格
                        "undo", // 撤销
                        "redo", // 重复      
                    ];
                } else if (this.type == 2) {
                    this.editor.config.zindex = 20000;
                    this.editor.config.menus = [
                        "bold", // 粗体
                        "fontSize", // 字号
                        "fontName", // 字体
                        "foreColor", // 文字颜色
                        "backColor", // 背景颜色
                    ];
                }

                if (this.barSet == 1) {
                    this.editor.config.menus = [
                        "bold", // 粗体
                        "fontSize", // 字号
                        "fontName", // 字体
                        "foreColor", // 文字颜色
                        "backColor", // 背景颜色
                        "underline", // 下划线
                        "italic", // 斜体
                        "strikeThrough", // 删除线
                        "list", //有序/无序列表
                        "justify", // 对齐方式
                    ];
                }
                this.editor.config.onchange = (html) => {
                    this.info_ = html; // 绑定当前逐渐地值
                    this.$emit("change", this.info_); // 将内容同步到父组件中
                };
                // 创建富文本编辑器
                this.editor.create();
            },
        },
    };
</script>
<!--[
  'bold',           // 加粗
  'italic',         // 斜体
  'underline',      // 下划线
  'strikeThrough',  // 删除线
  'fontSize',       // 字号
  'fontFamily',     // 字体
  'color',          // 字体颜色
  'bgColor',        // 背景颜色
  'indent',         // 缩进
  'lineHeight',     // 行高
  'head',           // 标题（H1~H6）
  'list',           // 有序/无序列表
  'todo',           // 待办列表（复选框）
  'justifyLeft',    // 左对齐
  'justifyRight',   // 右对齐
  'justifyCenter',  // 居中对齐
  'justifyJustify', // 两端对齐
  'emoticon',       // 表情
  'image',          // 图片
  'video',          // 视频
  'table',          // 表格
  'code',           // 行内代码 / 代码块
  'blockquote',     // 引用块
  'insertLink',     // 插入链接
  'undo',           // 撤销
  'redo',           // 重做
  'clearStyle',     // 清除格式
  'fullScreen'      // 全屏编辑
]
!-->
<style lang="css">
    .editor {
        width: 1000px;
        margin: 0 auto;
    }
    
    .toolbar .w-e-toolbar {
        width: 1000px;
        border: 1px solid #ccc;
    }
    
    .text {
        border: 1px solid #ccc;
        height: 380px;
    }
    
    .editor2 {
        width: 300px;
        margin: 0 auto;
    }
    
    .toolbar2 {
        width: 300px;
        border: 1px solid #ccc;
    }
    
    .toolbar3 {
        width: 100%;
        border: 1px solid #ccc;
    }
    
    .text2 {
        border: 1px solid #ccc;
        height: 100px;
    }
    
    .w-e-toolbar {
        background: rgb(255, 255, 255);
    }
</style>


// WEBPACK FOOTER //
// src/components/tools/wangEditor.vue